import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.9.2_db0@0.3.2_eslint@9.11.0_jiti@2.4.2_2407868f8ed0be20c0973ee9bbe6a5c7/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}